import { css } from '@emotion/react';
import { useHistory } from 'react-router-dom';
import Button from '@veeva/corgix/button';
import Dialog from './Dialog';
import useMessageService from '../services/i18n/useMessageService';
import { UnauthenticatedPaths } from '../constants/Paths';

const SessionExpiredDialog = () => {
    const history = useHistory();

    const [
        [
            myAccountSessionExpiredDialogTitle = 'Your Session has Expired',
            myAccountSessionExpiredDialogContent = 'Log in again to restart your session.',
            loginText = 'Log in',
        ],
        messagesLoading,
    ] = useMessageService([
        'my_account.session_expired_dialog_title',
        'my_account.session_expired_dialog_content',
        'general.log_in',
    ]);

    const handleContinue = () => {
        history.push(UnauthenticatedPaths.LOGIN);
    };

    const actions = [
        <Button
            css={({ orangeDefault }) => css`
                &:focus-visible {
                    outline: 2px solid ${orangeDefault};
                }
            `}
            key="continue"
            variant="primary"
            onClick={handleContinue}
        >
            {loginText}
        </Button>,
    ];

    if (messagesLoading) {
        return null;
    }

    return (
        <Dialog title={myAccountSessionExpiredDialogTitle} actions={actions} open>
            {myAccountSessionExpiredDialogContent}
        </Dialog>
    );
};

export default SessionExpiredDialog;
